import type { PlanFeatures } from "../components/settings/AccountsTab"

export type NavItem = {
  path: string
  icon: string
  label: string
  end?: boolean
  singleOnly?: boolean
  // 対応する Plan.features_for のキー。指定時、選択中アカウントがこの機能を持たなければ鍵アイコンを表示する
  feature?: keyof PlanFeatures
}

export const NAV_ITEMS: NavItem[] = [
  { path: "/",             icon: "bi-grid-1x2-fill",  label: "ダッシュボード",    end: true },
  { path: "/feed-posts",   icon: "bi-image",           label: "フィード・カルーセル" },
  { path: "/stories",      icon: "bi-circle",          label: "ストーリーズ" },
  { path: "/reels",        icon: "bi-play-btn",        label: "リール" },
  { path: "/hashtags",     icon: "bi-hash",            label: "ハッシュタグ分析",  singleOnly: true },
  { path: "/post-schedule",icon: "bi-calendar-check",  label: "予約投稿",          feature: "scheduled_post" },
  { path: "/categories",   icon: "bi-pie-chart",       label: "カテゴリ分析",      singleOnly: true, feature: "category" },
  { path: "/competitors",  icon: "bi-people",          label: "競合分析",          feature: "competitor" },
  { path: "/fan-users",    icon: "bi-person-heart",    label: "ファンユーザー分析", feature: "fan_user" },
  { path: "/ai-report",    icon: "bi-stars",           label: "AIレポート",        singleOnly: true, feature: "ai" },
]

export const PAGE_TITLES: Record<string, string> = {
  ...Object.fromEntries(NAV_ITEMS.map(({ path, label }) => [path, label])),
  "/settings":      "設定",
  "/notifications": "お知らせ",
  "/help":          "ヘルプ",
}
